<template>
  <div class="masonry-grid" ref="masonrygrid">
    <slot></slot>
  </div>
</template>


<script>
//import jQuery from 'jQuery'
import Masonry from 'masonry-layout'
export default {
  props: ['color','disabled'],
  data(){
    return {
      //joe: 123
      config: {
        itemSelector: '.masonry-grid-item',
        columnWidth: 140,
      },
      $masonrygrid: undefined,
    }
  },
  computed:{
  },
  methods: {
    reLayout(){
		console.log(this.$masonrygrid)
		this.$masonrygrid.masonry('layout')
    },
  },
  mounted: function() {
    //var $ = jQuery
    //console.log('mounted')
    //console.log(Masonry)
    //console.log( this.$refs.masonrygrid )
    //console.log( $(this.$el) )
    //$(this.$el).datepicker();
    this.$masonrygrid = new Masonry(this.$refs.masonrygrid, this.config)
    var _this = this
    setInterval(function(){
    //  _this.$masonrygrid.layout()
    }, 1000)

  },
  created(){
    //console.log(Masonry)
	var _this = this
	eventBus.$on('masonry_relayout', function() { _this.reLayout() })
  },
}
</script>



// WEBPACK FOOTER //
// Masonry.vue?78ffcefa